const ITEMS = [
  "Dubai Business Bay",
  "GCC Wholesale Distributor",
  "Women's Fabrics & Fashion",
  "Premium Arabic Wear",
  "Sportswear & Accessories",
  "Perfumes & Footwear",
  "Custom Private Labeling",
];

export default function Marquee() {
  const row = (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-display italic text-2xl sm:text-3xl text-[#D4AF37]/50 whitespace-nowrap px-8">{item}</span>
          <span className="w-1.5 h-1.5 rotate-45 bg-[#D4AF37]/40" />
        </span>
      ))}
    </div>
  );

  return (
    <div data-testid="editorial-marquee" className="relative py-8 border-y border-[#D4AF37]/15 bg-[#0A0B0E] overflow-hidden">
      <div className="flex w-max animate-marquee">
        {row}
        {row}
      </div>
    </div>
  );
}
